const INITIAL_STATE = {list: []}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'TROCAPLANO_FETCHED':
            return { ...state, list: action.payload.data }
        case 'TROCAPLANO_PAGE':
            return { ...state, paginaAtual: action.payload };
        default:
            return state
    }
}